// The small field shapes the owner report's two schema files share. Private to this folder: not in its index.
import { z } from 'zod';
import { SOCIAL_REPORT_MONTH_PATTERN } from '../social-report/social-report-schemas';

/** "YYYY-MM", a salon-local calendar month (same format as the social report). */
export const reportMonthSchema = z.string().regex(SOCIAL_REPORT_MONTH_PATTERN);
export const count = z.number().int().nonnegative();
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

/**
 * A payload block added after the first release: null when absent, so a new landing page survives an old API in the
 * minutes between deploys. Every block built this way stays nullable for good; a reader must handle null.
 */
export const addedBlock = <T extends z.ZodTypeAny>(block: T) => block.nullable().default(null);
